import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    round: 'Round',
    join: 'Enter for',
    leave: 'Leave',
    starting: 'Starting…',
    youWon: 'You won',
    youTookAll: 'You took it all',
    yourSideWon: 'Your side won',
    playerWon: '{{name}} won',
    howHighest: 'Dropped the most — {{amount}}',
    howLowest: 'Dropped the least — {{amount}}',
    howLastCase: 'Last case drop — {{amount}}',
    howSideHighest: 'Dropped more:',
    howSideLowest: 'Dropped less:',
    versus: 'vs',
    howTied: 'Dropped the same — {{amount}} each',
    tookAllDropped: 'everything dropped, all players',
    eachFromDropped: 'each, out of {{amount}} dropped',
    received: 'Received',
    superDrop: 'Super drop',
    finalRound: 'Decisive round',
    finalRoundHint: 'Only this drop counts',
    sharingTitle: 'Everyone wins',
    teamWon: 'Winning team',
    tie: 'Tie',
    dropped: 'Dropped',
    lastDrop: 'Last drop',
    errorJoining: 'Failed to join the battle',
    errMultiacc: 'You cannot join this battle',
    errorLeaving: 'Failed to leave the battle',
    errorReady: 'Failed to update readiness',
    you: 'You',
    playerFallback: 'Player',
    preparingAnimation: 'Preparing the replay…',
    lobbySlotFree: 'Open',
    lobbyYou: 'You',
    takeSeat: 'Take this seat',
    gathering: 'Gathering players',
    bandStartsAt: 'Starts at {{time}} Moscow time',
    privateTitle: 'Private battle',
    privateHint: 'It is hidden from the list. Send the link to the people you want in.',
    readyBadge: 'ready',
    startNowTitle: 'Start right away',
    readyCount: '{{count}} of {{total}} ready',
    topUpShort: '{{missing}} short — top up',
    addTradeLink: 'Set your trade link',
    joinConfirmTitle: 'Join the battle?',
    chooseSide: 'Which team?',
    sideFull: 'Taken',
    cancel: 'Cancel',
    modeRuleTitle: 'How the winner is decided',
    viewersTitle: 'Who is watching',
    watching: 'Watching: {{count}}',
    viewerPlaying: 'Playing',
    viewerWatching: 'Watching',
    viewersEmpty: 'Nobody yet',
    sellDrops: 'Sell all for',
    sellConfirmTitle: 'Sell all the drops?',
    sellConfirmText: 'The items go straight from your inventory into coins. There is no undo.',
    soldFor: 'Sold. {{amount}} is on your balance',
    sellFailed: 'Could not sell',
    repeatLineup: 'Repeat the battle',
    recreateBattle: 'Recreate the battle',
    recreateLimit: 'Active battles limit reached',
    recreateFailed: 'Could not create the battle',
    replay: 'Watch again',
    toBattles: 'To battles',
    rematchOf: 'This is a rematch — open the first battle',
    cancelledTitle: 'Battle called off',
    cancelledTimeout: 'Nobody joined within 10 minutes',
    cancelledEmpty: 'Everyone left',
    cancelledProcessing: 'The draw failed, entries were returned',
    cancelledBandFailed: 'The battle could not be played — we are already on it. Payouts will arrive as soon as we fix it.',
    cancelledBandCarried: 'The headliners battle did not take place — the cases for it ran out. The amount for cases moves to next week.',
    refunded: 'Your entry of {{amount}} is back on the balance',
    share: 'Share',
    inviteFriend: 'Invite a friend',
    inviteText: 'Jump into my case battle on SHOT — there is a seat for you',
    inviteButton: 'Play',
    linkCopied: 'Link copied',
  },
  ru: {
    round: 'Раунд',
    join: 'Вступить за',
    leave: 'Выйти',
    starting: 'Начинаем…',
    youWon: 'Ты победил',
    youTookAll: 'Ты забрал всё',
    yourSideWon: 'Твоя сторона победила',
    playerWon: 'Победил {{name}}',
    howHighest: 'Выбил больше всех — {{amount}}',
    howLowest: 'Выбил меньше всех — {{amount}}',
    howLastCase: 'Дроп последнего кейса — {{amount}}',
    howSideHighest: 'Выбили больше:',
    howSideLowest: 'Выбили меньше:',
    versus: 'против',
    howTied: 'Выбили поровну — по {{amount}}',
    tookAllDropped: 'всё выбитое всеми игроками',
    eachFromDropped: 'каждому из {{amount}} выбитых',
    received: 'Получил',
    superDrop: 'Супер дроп',
    finalRound: 'Решающий раунд',
    finalRoundHint: 'Считается только этот дроп',
    sharingTitle: 'Делим поровну',
    teamWon: 'Победила команда',
    tie: 'Ничья',
    dropped: 'Выбито',
    lastDrop: 'Последний дроп',
    errorJoining: 'Не удалось присоединиться',
    errMultiacc: 'Ты не можешь участвовать в этом баттле',
    errorLeaving: 'Не удалось выйти',
    errorReady: 'Не удалось отметить готовность',
    you: 'Ты',
    playerFallback: 'Игрок',
    preparingAnimation: 'Готовим показ раунда…',
    lobbySlotFree: 'Свободно',
    lobbyYou: 'Ты',
    takeSeat: 'Сесть сюда',
    gathering: 'Собираем игроков',
    bandStartsAt: 'Начнётся в {{time}} по Москве',
    privateTitle: 'Приватный баттл',
    privateHint: 'В списке его нет. Отправь ссылку тем, кого ждёшь.',
    readyBadge: 'готов',
    startNowTitle: 'Стартовать сейчас',
    readyCount: '{{count}} из {{total}} готовы',
    topUpShort: 'Не хватает {{missing}} — пополнить',
    addTradeLink: 'Указать трейд-ссылку',
    joinConfirmTitle: 'Вступить в баттл?',
    chooseSide: 'За какую команду?',
    sideFull: 'Занято',
    cancel: 'Отмена',
    modeRuleTitle: 'Как определяется победитель',
    viewersTitle: 'Кто смотрит',
    watching: 'Смотрят: {{count}}',
    viewerPlaying: 'Играет',
    viewerWatching: 'Смотрит',
    viewersEmpty: 'Пока никого',
    sellDrops: 'Продать все за',
    sellConfirmTitle: 'Продать все дропы?',
    sellConfirmText: 'Предметы уйдут из инвентаря, монеты придут на баланс. Отменить нельзя.',
    soldFor: 'Продано. {{amount}} уже на балансе',
    sellFailed: 'Продать не получилось',
    repeatLineup: 'Повторить баттл',
    recreateBattle: 'Пересоздать баттл',
    recreateLimit: 'Достигнут лимит активных баттлов',
    recreateFailed: 'Не удалось создать баттл',
    replay: 'Пересмотреть',
    toBattles: 'К баттлам',
    rematchOf: 'Это реванш — открыть первый баттл',
    cancelledTitle: 'Баттл отменён',
    cancelledTimeout: 'За 10 минут никто не вступил',
    cancelledEmpty: 'Все участники вышли',
    cancelledProcessing: 'Розыгрыш не удался, входы вернули',
    cancelledBandFailed: 'Баттл не удалось разыграть — мы уже разбираемся. Выплаты придут, как только починим.',
    cancelledBandCarried: 'Баттл хедлайнеров не состоялся — кейсы для него закончились. Сумма на кейсы переходит на следующую неделю.',
    refunded: 'Твой вход {{amount}} снова на балансе',
    share: 'Поделиться',
    inviteFriend: 'Позвать друга',
    inviteText: 'Залетай в мой кейс-баттл на SHOT — место есть',
    inviteButton: 'Играть',
    linkCopied: 'Ссылка скопирована',
  },
  uz: {
    round: 'Raund',
    join: 'Qoʻshilish',
    leave: 'Chiqish',
    starting: 'Boshlaymiz…',
    youWon: 'Sen yutding',
    youTookAll: 'Hammasini olding',
    yourSideWon: 'Sening tomoning yutdi',
    playerWon: '{{name}} yutdi',
    howHighest: 'Eng koʻp tushirdi — {{amount}}',
    howLowest: 'Eng kam tushirdi — {{amount}}',
    howLastCase: 'Oxirgi keys dropi — {{amount}}',
    howSideHighest: 'Koʻproq tushirdi:',
    howSideLowest: 'Kamroq tushirdi:',
    versus: 'va',
    howTied: 'Teng tushirdi — har biri {{amount}}',
    tookAllDropped: 'barcha oʻyinchilarga tushgan hamma narsa',
    eachFromDropped: 'har biriga, tushgan {{amount}} dan',
    received: 'Oldi',
    superDrop: 'Super drop',
    finalRound: 'Hal qiluvchi raund',
    finalRoundHint: 'Faqat shu drop hisobga olinadi',
    sharingTitle: 'Teng boʻlamiz',
    teamWon: 'Gʻolib jamoa',
    tie: 'Durang',
    dropped: 'Tushdi',
    lastDrop: 'Oxirgi drop',
    errorJoining: 'Qoʻshilib boʻlmadi',
    errMultiacc: 'Sen bu battleda ishtirok eta olmaysan',
    errorLeaving: 'Chiqib boʻlmadi',
    errorReady: 'Tayyorlikni belgilab boʻlmadi',
    you: 'Sen',
    playerFallback: 'Oʻyinchi',
    preparingAnimation: 'Raund koʻrsatuvi tayyorlanmoqda…',
    lobbySlotFree: 'Boʻsh',
    lobbyYou: 'Sen',
    takeSeat: 'Shu joyga oʻtirish',
    gathering: 'Oʻyinchilarni yigʻamiz',
    bandStartsAt: 'Moskva vaqti bilan {{time}} da boshlanadi',
    privateTitle: 'Shaxsiy battle',
    privateHint: 'Roʻyxatda koʻrinmaydi. Havolani kutayotganlaringga yubor.',
    readyBadge: 'tayyor',
    startNowTitle: 'Hoziroq boshlash',
    readyCount: '{{total}} dan {{count}} tayyor',
    topUpShort: '{{missing}} yetmaydi — toʻldirish',
    addTradeLink: 'Trade-havolani koʻrsatish',
    joinConfirmTitle: 'Battlega qoʻshilasanmi?',
    chooseSide: 'Qaysi jamoaga?',
    sideFull: 'Band',
    cancel: 'Bekor qilish',
    modeRuleTitle: 'Gʻolib qanday aniqlanadi',
    viewersTitle: 'Kim tomosha qilyapti',
    watching: 'Tomosha qilmoqda: {{count}}',
    viewerPlaying: 'Oʻynayapti',
    viewerWatching: 'Tomosha qilyapti',
    viewersEmpty: 'Hozircha hech kim',
    sellDrops: 'Hammasini sotish:',
    sellConfirmTitle: 'Barcha droplarni sotasanmi?',
    sellConfirmText: 'Buyumlar inventardan ketadi, tangalar balansga tushadi. Bekor qilib boʻlmaydi.',
    soldFor: 'Sotildi. {{amount}} allaqachon balansda',
    sellFailed: 'Sotib boʻlmadi',
    repeatLineup: 'Jangni takrorlash',
    recreateBattle: 'Jangni qayta yaratish',
    recreateLimit: 'Faol janglar chegarasiga yetildi',
    recreateFailed: 'Jangni yaratib boʻlmadi',
    replay: 'Qayta koʻrish',
    toBattles: 'Battlelarga',
    rematchOf: 'Bu revansh — birinchi battleni ochish',
    cancelledTitle: 'Battle bekor qilindi',
    cancelledTimeout: '10 daqiqada hech kim qoʻshilmadi',
    cancelledEmpty: 'Barcha ishtirokchilar chiqib ketdi',
    cancelledProcessing: 'Oʻyin oʻtmadi, kirishlar qaytarildi',
    cancelledBandFailed: 'Battlni oʻtkazib boʻlmadi — allaqachon tekshiryapmiz. Tuzatishimiz bilan toʻlovlar tushadi.',
    cancelledBandCarried: 'Xedlaynerlar battli boʻlmadi — uning uchun keyslar tugab qoldi. Keyslar uchun summa keyingi haftaga oʻtadi.',
    refunded: 'Sening {{amount}} kirishing yana balansda',
    share: 'Ulashish',
    inviteFriend: 'Doʻstni chaqirish',
    inviteText: 'SHOTdagi keys-battlimga kir — joy bor',
    inviteButton: 'Oʻynash',
    linkCopied: 'Havola nusxalandi',
  },
  fa: {
    round: 'راند',
    join: 'ورود با',
    leave: 'خروج',
    starting: 'شروع می‌کنیم…',
    youWon: 'تو بردی',
    youTookAll: 'همه را بردی',
    yourSideWon: 'طرف تو برد',
    playerWon: '{{name}} برد',
    howHighest: 'بیشترین دراپ — {{amount}}',
    howLowest: 'کمترین دراپ — {{amount}}',
    howLastCase: 'دراپ کیس آخر — {{amount}}',
    howSideHighest: 'دراپ بیشتر:',
    howSideLowest: 'دراپ کمتر:',
    versus: 'مقابل',
    howTied: 'دراپ برابر — هر نفر {{amount}}',
    tookAllDropped: 'همهٔ دراپ‌های همهٔ بازیکنان',
    eachFromDropped: 'به هر نفر، از {{amount}} دراپ',
    received: 'دریافت کرد',
    superDrop: 'سوپر دراپ',
    finalRound: 'راند تعیین‌کننده',
    finalRoundHint: 'فقط همین دراپ حساب می‌شود',
    sharingTitle: 'مساوی تقسیم می‌کنیم',
    teamWon: 'تیم برنده',
    tie: 'مساوی',
    dropped: 'افتاده',
    lastDrop: 'آخرین دراپ',
    errorJoining: 'پیوستن به بتل نشد',
    errMultiacc: 'نمی‌توانی وارد این بتل شوی',
    errorLeaving: 'خروج نشد',
    errorReady: 'ثبت آمادگی نشد',
    you: 'تو',
    playerFallback: 'بازیکن',
    preparingAnimation: 'در حال آماده‌سازی پخش…',
    lobbySlotFree: 'خالی',
    lobbyYou: 'تو',
    takeSeat: 'اینجا بنشین',
    gathering: 'جمع کردن بازیکن‌ها',
    bandStartsAt: 'ساعت {{time}} به وقت مسکو شروع می‌شود',
    privateTitle: 'بتل خصوصی',
    privateHint: 'در فهرست دیده نمی‌شود. لینک را برای کسانی که منتظرشان هستی بفرست.',
    readyBadge: 'آماده',
    startNowTitle: 'همین حالا شروع کن',
    readyCount: '{{count}} از {{total}} آماده',
    topUpShort: '{{missing}} کم است — شارژ کن',
    addTradeLink: 'لینک ترید را بگذار',
    joinConfirmTitle: 'وارد بتل می‌شوی؟',
    chooseSide: 'کدام تیم؟',
    sideFull: 'پر است',
    cancel: 'بی‌خیال',
    modeRuleTitle: 'برنده چطور مشخص می‌شود',
    viewersTitle: 'چه کسی تماشا می‌کند',
    watching: 'تماشاگر: {{count}}',
    viewerPlaying: 'بازی می‌کند',
    viewerWatching: 'تماشا می‌کند',
    viewersEmpty: 'هنوز کسی نیست',
    sellDrops: 'فروش همه با',
    sellConfirmTitle: 'همه دراپ‌ها فروخته شود؟',
    sellConfirmText: 'آیتم‌ها از انبار می‌روند و سکه‌ها به موجودی می‌آیند. برگشت ندارد.',
    soldFor: 'فروخته شد. {{amount}} روی موجودی است',
    sellFailed: 'فروش نشد',
    repeatLineup: 'تکرار نبرد',
    recreateBattle: 'ساخت دوباره نبرد',
    recreateLimit: 'به سقف نبردهای فعال رسیدی',
    recreateFailed: 'ساخت نبرد انجام نشد',
    replay: 'تماشای دوباره',
    toBattles: 'به بتل‌ها',
    rematchOf: 'این بازی مجدد است — باز کردن بتل اول',
    cancelledTitle: 'بتل لغو شد',
    cancelledTimeout: 'در 10 دقیقه کسی نیامد',
    cancelledEmpty: 'همه شرکت‌کننده‌ها رفتند',
    cancelledProcessing: 'قرعه انجام نشد، ورودی‌ها برگشت',
    cancelledBandFailed: 'بتل انجام نشد — در حال بررسی هستیم. به‌محض رفع مشکل، پرداخت‌ها انجام می‌شود.',
    cancelledBandCarried: 'بتل هدلاینرها برگزار نشد — کیس‌هایش تمام شد. مبلغ کیس‌ها به هفتهٔ بعد منتقل می‌شود.',
    refunded: 'ورودی {{amount}} تو دوباره روی موجودی است',
    share: 'اشتراک',
    inviteFriend: 'دعوت دوست',
    inviteText: 'بپر توی کیس‌بتل من در SHOT — جا هست',
    inviteButton: 'بازی',
    linkCopied: 'لینک کپی شد',
  },
  pt: {
    round: 'Rodada',
    join: 'Entrar por',
    leave: 'Sair',
    starting: 'Começando…',
    youWon: 'Você venceu',
    youTookAll: 'Você levou tudo',
    yourSideWon: 'Seu lado venceu',
    playerWon: '{{name}} venceu',
    howHighest: 'Tirou o maior drop — {{amount}}',
    howLowest: 'Tirou o menor drop — {{amount}}',
    howLastCase: 'Drop da última caixa — {{amount}}',
    howSideHighest: 'Tiraram mais:',
    howSideLowest: 'Tiraram menos:',
    versus: 'contra',
    howTied: 'Tiraram o mesmo — {{amount}} cada',
    tookAllDropped: 'tudo que caiu para todos os jogadores',
    eachFromDropped: 'cada um, de {{amount}} que caíram',
    received: 'Recebeu',
    superDrop: 'Super drop',
    finalRound: 'Rodada decisiva',
    finalRoundHint: 'Só este drop conta',
    sharingTitle: 'Dividimos igual',
    teamWon: 'Time vencedor',
    tie: 'Empate',
    dropped: 'Caiu',
    lastDrop: 'Último drop',
    errorJoining: 'Não foi possível entrar na batalha',
    errMultiacc: 'Você não pode participar desta batalha',
    errorLeaving: 'Não foi possível sair da batalha',
    errorReady: 'Não foi possível marcar como pronto',
    you: 'Você',
    playerFallback: 'Jogador',
    preparingAnimation: 'Preparando o replay…',
    lobbySlotFree: 'Livre',
    lobbyYou: 'Você',
    takeSeat: 'Sentar aqui',
    gathering: 'Reunindo jogadores',
    bandStartsAt: 'Começa às {{time}} no horário de Moscou',
    privateTitle: 'Batalha privada',
    privateHint: 'Ela não aparece na lista. Mande o link para quem você quer dentro.',
    readyBadge: 'pronto',
    startNowTitle: 'Começar agora',
    readyCount: '{{count}} de {{total}} prontos',
    topUpShort: 'Faltam {{missing}} — depositar',
    addTradeLink: 'Informar o link de troca',
    joinConfirmTitle: 'Entrar na batalha?',
    chooseSide: 'Qual time?',
    sideFull: 'Ocupado',
    cancel: 'Cancelar',
    modeRuleTitle: 'Como o vencedor é definido',
    viewersTitle: 'Quem está assistindo',
    watching: 'Assistindo: {{count}}',
    viewerPlaying: 'Jogando',
    viewerWatching: 'Assistindo',
    viewersEmpty: 'Ninguém ainda',
    sellDrops: 'Vender tudo por',
    sellConfirmTitle: 'Vender todos os drops?',
    sellConfirmText: 'Os itens saem do inventário e as moedas vão para o saldo. Não dá para desfazer.',
    soldFor: 'Vendido. {{amount}} já está no seu saldo',
    sellFailed: 'Não foi possível vender',
    repeatLineup: 'Repetir a batalha',
    recreateBattle: 'Recriar a batalha',
    recreateLimit: 'Limite de batalhas ativas atingido',
    recreateFailed: 'Não foi possível criar a batalha',
    replay: 'Ver de novo',
    toBattles: 'Para as batalhas',
    rematchOf: 'Isto é uma revanche — abrir a primeira batalha',
    cancelledTitle: 'Batalha cancelada',
    cancelledTimeout: 'Ninguém entrou em 10 minutos',
    cancelledEmpty: 'Todos saíram',
    cancelledProcessing: 'O sorteio falhou, as entradas foram devolvidas',
    cancelledBandFailed: 'Não foi possível jogar a battle — já estamos resolvendo. Os pagamentos chegam assim que corrigirmos.',
    cancelledBandCarried: 'A battle dos headliners não aconteceu — as caixas para ela acabaram. O valor para as caixas passa para a próxima semana.',
    refunded: 'Sua entrada de {{amount}} voltou para o saldo',
    share: 'Compartilhar',
    inviteFriend: 'Chamar um amigo',
    inviteText: 'Entra na minha batalha de caixas no SHOT — tem vaga para você',
    inviteButton: 'Jogar',
    linkCopied: 'Link copiado',
  },
  tr: {
    round: 'Raund',
    join: 'Katıl:',
    leave: 'Ayrıl',
    starting: 'Başlıyor…',
    youWon: 'Kazandın',
    youTookAll: 'Hepsini aldın',
    yourSideWon: 'Senin tarafın kazandı',
    playerWon: '{{name}} kazandı',
    howHighest: 'En çok düşüren — {{amount}}',
    howLowest: 'En az düşüren — {{amount}}',
    howLastCase: 'Son kasanın dropu — {{amount}}',
    howSideHighest: 'Daha çok düşürdü:',
    howSideLowest: 'Daha az düşürdü:',
    versus: 'vs',
    howTied: 'Eşit düşürdüler — {{amount}} her biri',
    tookAllDropped: 'tüm oyuncuların düşürdüğü her şey',
    eachFromDropped: 'her biri, düşen {{amount}} içinden',
    received: 'Aldı',
    superDrop: 'Süper drop',
    finalRound: 'Belirleyici raund',
    finalRoundHint: 'Sadece bu drop sayılır',
    sharingTitle: 'Eşit paylaşım',
    teamWon: 'Kazanan takım',
    tie: 'Berabere',
    dropped: 'Düşen',
    lastDrop: 'Son drop',
    errorJoining: 'Savaşa katılınamadı',
    errMultiacc: 'Bu savaşa katılamazsın',
    errorLeaving: 'Savaştan ayrılınamadı',
    errorReady: 'Hazır durumu güncellenemedi',
    you: 'Sen',
    playerFallback: 'Oyuncu',
    preparingAnimation: 'Tekrar hazırlanıyor…',
    lobbySlotFree: 'Boş',
    lobbyYou: 'Sen',
    takeSeat: 'Buraya otur',
    gathering: 'Oyuncular toplanıyor',
    bandStartsAt: 'Başlangıç: Moskova saatiyle {{time}}',
    privateTitle: 'Özel savaş',
    privateHint: 'Listede görünmez. Linki beklediğin kişilere gönder.',
    readyBadge: 'hazır',
    startNowTitle: 'Hemen başlat',
    readyCount: '{{total}} kişiden {{count}} hazır',
    topUpShort: '{{missing}} eksik — yatır',
    addTradeLink: 'Takas linkini gir',
    joinConfirmTitle: 'Savaşa katılıyor musun?',
    chooseSide: 'Hangi takım?',
    sideFull: 'Dolu',
    cancel: 'İptal',
    modeRuleTitle: 'Kazanan nasıl belirlenir',
    viewersTitle: 'Kim izliyor',
    watching: 'İzleyen: {{count}}',
    viewerPlaying: 'Oynuyor',
    viewerWatching: 'İzliyor',
    viewersEmpty: 'Henüz kimse yok',
    sellDrops: 'Hepsini sat:',
    sellConfirmTitle: 'Tüm droplar satılsın mı?',
    sellConfirmText: 'Eşyalar envanterden çıkar, coinler bakiyene gelir. Geri alınamaz.',
    soldFor: 'Satıldı. {{amount}} bakiyende',
    sellFailed: 'Satılamadı',
    repeatLineup: 'Savaşı tekrarla',
    recreateBattle: 'Savaşı yeniden oluştur',
    recreateLimit: 'Aktif savaş sınırına ulaşıldı',
    recreateFailed: 'Savaş oluşturulamadı',
    replay: 'Tekrar izle',
    toBattles: 'Savaşlara',
    rematchOf: 'Bu bir rövanş — ilk savaşı aç',
    cancelledTitle: 'Savaş iptal edildi',
    cancelledTimeout: '10 dakika içinde kimse katılmadı',
    cancelledEmpty: 'Herkes ayrıldı',
    cancelledProcessing: 'Çekiliş başarısız oldu, girişler iade edildi',
    cancelledBandFailed: 'Battle oynatılamadı — üzerinde çalışıyoruz. Düzelttiğimiz anda ödemeler gelecek.',
    cancelledBandCarried: 'Headliner battle’ı yapılamadı — kasaları tükendi. Kasalar için ayrılan tutar gelecek haftaya aktarılıyor.',
    refunded: '{{amount}} girişin bakiyene geri döndü',
    share: 'Paylaş',
    inviteFriend: 'Arkadaş çağır',
    inviteText: "SHOT'taki kasa savaşıma gel — senin için yer var",
    inviteButton: 'Oyna',
    linkCopied: 'Link kopyalandı',
  },
  uk: {
    round: 'Раунд',
    join: 'Вступити за',
    leave: 'Вийти',
    starting: 'Починаємо…',
    youWon: 'Ти переміг',
    youTookAll: 'Ти забрав усе',
    yourSideWon: 'Твоя сторона перемогла',
    playerWon: 'Переміг {{name}}',
    howHighest: 'Вибив найбільше — {{amount}}',
    howLowest: 'Вибив найменше — {{amount}}',
    howLastCase: 'Дроп останнього кейса — {{amount}}',
    howSideHighest: 'Вибили більше:',
    howSideLowest: 'Вибили менше:',
    versus: 'проти',
    howTied: 'Вибили порівну — по {{amount}}',
    tookAllDropped: 'усе вибите всіма гравцями',
    eachFromDropped: 'кожному з {{amount}} вибитих',
    received: 'Отримав',
    superDrop: 'Супердроп',
    finalRound: 'Вирішальний раунд',
    finalRoundHint: 'Рахується тільки цей дроп',
    sharingTitle: 'Ділимо порівну',
    teamWon: 'Перемогла команда',
    tie: 'Нічия',
    dropped: 'Випало',
    lastDrop: 'Останній дроп',
    errorJoining: 'Не вдалося приєднатися',
    errMultiacc: 'Ти не можеш брати участь у цьому батлі',
    errorLeaving: 'Не вдалося вийти',
    errorReady: 'Не вдалося позначити готовність',
    you: 'Ти',
    playerFallback: 'Гравець',
    preparingAnimation: 'Готуємо показ раунду…',
    lobbySlotFree: 'Вільно',
    lobbyYou: 'Ти',
    takeSeat: 'Сісти сюди',
    gathering: 'Збираємо гравців',
    bandStartsAt: 'Почнеться о {{time}} за Москвою',
    privateTitle: 'Приватний батл',
    privateHint: 'У списку його немає. Надішли посилання тим, кого чекаєш.',
    readyBadge: 'готовий',
    startNowTitle: 'Стартувати зараз',
    readyCount: '{{count}} із {{total}} готові',
    topUpShort: 'Не вистачає {{missing}} — поповнити',
    addTradeLink: 'Вказати трейд-посилання',
    joinConfirmTitle: 'Вступити в батл?',
    chooseSide: 'За яку команду?',
    sideFull: 'Зайнято',
    cancel: 'Скасувати',
    modeRuleTitle: 'Як визначається переможець',
    viewersTitle: 'Хто дивиться',
    watching: 'Дивляться: {{count}}',
    viewerPlaying: 'Грає',
    viewerWatching: 'Дивиться',
    viewersEmpty: 'Поки нікого',
    sellDrops: 'Продати все за',
    sellConfirmTitle: 'Продати всі дропи?',
    sellConfirmText: 'Предмети підуть з інвентаря, монети прийдуть на баланс. Скасувати не можна.',
    soldFor: 'Продано. {{amount}} уже на балансі',
    sellFailed: 'Продати не вдалося',
    repeatLineup: 'Повторити батл',
    recreateBattle: 'Створити батл заново',
    recreateLimit: 'Досягнуто ліміт активних батлів',
    recreateFailed: 'Не вдалося створити батл',
    replay: 'Передивитися',
    toBattles: 'До батлів',
    rematchOf: 'Це реванш — відкрити перший батл',
    cancelledTitle: 'Батл скасовано',
    cancelledTimeout: 'За 10 хвилин ніхто не вступив',
    cancelledEmpty: 'Усі учасники вийшли',
    cancelledProcessing: 'Розіграш не вдався, входи повернули',
    cancelledBandFailed: 'Батл не вдалося розіграти — ми вже розбираємось. Виплати прийдуть, щойно полагодимо.',
    cancelledBandCarried:
      'Батл хедлайнерів не відбувся — кейси для нього закінчились. Сума на кейси переходить на наступний тиждень.',
    refunded: 'Твій вхід {{amount}} знову на балансі',
    share: 'Поділитися',
    inviteFriend: 'Покликати друга',
    inviteText: 'Залітай у мій кейс-батл на SHOT — місце є',
    inviteButton: 'Грати',
    linkCopied: 'Посилання скопійовано',
  },
  de: {
    round: 'Runde',
    join: 'Beitreten für',
    leave: 'Verlassen',
    starting: 'Startet…',
    youWon: 'Du hast gewonnen',
    youTookAll: 'Du hast alles geholt',
    yourSideWon: 'Deine Seite hat gewonnen',
    playerWon: '{{name}} hat gewonnen',
    howHighest: 'Am meisten gedroppt – {{amount}}',
    howLowest: 'Am wenigsten gedroppt – {{amount}}',
    howLastCase: 'Drop der letzten Case – {{amount}}',
    howSideHighest: 'Mehr gedroppt:',
    howSideLowest: 'Weniger gedroppt:',
    versus: 'gegen',
    howTied: 'Gleich viel gedroppt – je {{amount}}',
    tookAllDropped: 'alles, was alle Spieler gedroppt haben',
    eachFromDropped: 'je aus {{amount}} gedroppt',
    received: 'Erhalten',
    superDrop: 'Super-Drop',
    finalRound: 'Entscheidende Runde',
    finalRoundHint: 'Nur dieser Drop zählt',
    sharingTitle: 'Alle gewinnen',
    teamWon: 'Siegerteam',
    tie: 'Unentschieden',
    dropped: 'Gedroppt',
    lastDrop: 'Letzter Drop',
    errorJoining: 'Beitritt fehlgeschlagen',
    errMultiacc: 'Du kannst an diesem Battle nicht teilnehmen',
    errorLeaving: 'Verlassen fehlgeschlagen',
    errorReady: 'Bereitschaft konnte nicht gesetzt werden',
    you: 'Du',
    playerFallback: 'Spieler',
    preparingAnimation: 'Wiederholung wird vorbereitet…',
    lobbySlotFree: 'Frei',
    lobbyYou: 'Du',
    takeSeat: 'Platz nehmen',
    gathering: 'Spieler werden gesucht',
    bandStartsAt: 'Beginnt um {{time}} Moskauer Zeit',
    privateTitle: 'Privates Battle',
    privateHint: 'Es erscheint nicht in der Liste. Schick den Link an die, die du dabeihaben willst.',
    readyBadge: 'bereit',
    startNowTitle: 'Sofort starten',
    readyCount: '{{count}} von {{total}} bereit',
    topUpShort: '{{missing}} fehlen – aufladen',
    addTradeLink: 'Trade-Link angeben',
    joinConfirmTitle: 'Dem Battle beitreten?',
    chooseSide: 'Welches Team?',
    sideFull: 'Besetzt',
    cancel: 'Abbrechen',
    modeRuleTitle: 'So wird der Gewinner ermittelt',
    viewersTitle: 'Wer zuschaut',
    watching: 'Zuschauer: {{count}}',
    viewerPlaying: 'Spielt',
    viewerWatching: 'Schaut zu',
    viewersEmpty: 'Noch niemand',
    sellDrops: 'Alles verkaufen für',
    sellConfirmTitle: 'Alle Drops verkaufen?',
    sellConfirmText:
      'Die Items verschwinden aus deinem Inventar, die Münzen landen auf deinem Guthaben. Das lässt sich nicht rückgängig machen.',
    soldFor: 'Verkauft. {{amount}} sind schon auf deinem Guthaben',
    sellFailed: 'Verkauf nicht möglich',
    repeatLineup: 'Battle wiederholen',
    recreateBattle: 'Battle neu erstellen',
    recreateLimit: 'Limit aktiver Battles erreicht',
    recreateFailed: 'Battle konnte nicht erstellt werden',
    replay: 'Nochmal ansehen',
    toBattles: 'Zu den Battles',
    rematchOf: 'Das ist ein Rückkampf – ersten Battle öffnen',
    cancelledTitle: 'Battle abgesagt',
    cancelledTimeout: 'Innerhalb von 10 Minuten ist niemand beigetreten',
    cancelledEmpty: 'Alle Teilnehmer sind gegangen',
    cancelledProcessing: 'Die Auslosung ist fehlgeschlagen, die Eintritte wurden zurückgegeben',
    cancelledBandFailed:
      'Das Battle konnte nicht gespielt werden – wir kümmern uns schon darum. Die Auszahlungen kommen, sobald wir es behoben haben.',
    cancelledBandCarried:
      'Das Headliner-Battle hat nicht stattgefunden – die Cases dafür sind ausgegangen. Der Betrag für Cases wird auf die nächste Woche übertragen.',
    refunded: 'Dein Eintritt von {{amount}} ist wieder auf deinem Guthaben',
    share: 'Teilen',
    inviteFriend: 'Freund einladen',
    inviteText: 'Komm in mein Case Battle auf SHOT – ein Platz ist frei',
    inviteButton: 'Spielen',
    linkCopied: 'Link kopiert',
  },
  es: {
    round: 'Ronda',
    join: 'Unirse por',
    leave: 'Salir',
    starting: 'Empezando…',
    youWon: 'Has ganado',
    youTookAll: 'Te lo llevaste todo',
    yourSideWon: 'Tu lado ganó',
    playerWon: 'Ganó {{name}}',
    howHighest: 'Dropeó más que nadie: {{amount}}',
    howLowest: 'Dropeó menos que nadie: {{amount}}',
    howLastCase: 'Drop de la última caja: {{amount}}',
    howSideHighest: 'Dropearon más:',
    howSideLowest: 'Dropearon menos:',
    versus: 'contra',
    howTied: 'Dropearon lo mismo: {{amount}} cada uno',
    tookAllDropped: 'todo lo que dropearon todos los jugadores',
    eachFromDropped: 'a cada uno, de {{amount}} dropeados',
    received: 'Recibido',
    superDrop: 'Súper drop',
    finalRound: 'Ronda decisiva',
    finalRoundHint: 'Solo cuenta este drop',
    sharingTitle: 'Se reparte por igual',
    teamWon: 'Equipo ganador',
    tie: 'Empate',
    dropped: 'Dropeado',
    lastDrop: 'Último drop',
    errorJoining: 'No se pudo unirse',
    errMultiacc: 'No puedes participar en este battle',
    errorLeaving: 'No se pudo salir',
    errorReady: 'No se pudo marcar que estás listo',
    you: 'Tú',
    playerFallback: 'Jugador',
    preparingAnimation: 'Preparando la repetición…',
    lobbySlotFree: 'Libre',
    lobbyYou: 'Tú',
    takeSeat: 'Sentarse aquí',
    gathering: 'Reuniendo jugadores',
    bandStartsAt: 'Empieza a las {{time}}, hora de Moscú',
    privateTitle: 'Battle privado',
    privateHint: 'No aparece en la lista. Envía el enlace a quienes quieras que entren.',
    readyBadge: 'listo',
    startNowTitle: 'Empezar ya',
    readyCount: '{{count}} de {{total}} listos',
    topUpShort: 'Faltan {{missing}}: recargar',
    addTradeLink: 'Indicar enlace de intercambio',
    joinConfirmTitle: '¿Unirte al battle?',
    chooseSide: '¿Qué equipo?',
    sideFull: 'Ocupado',
    cancel: 'Cancelar',
    modeRuleTitle: 'Cómo se decide el ganador',
    viewersTitle: 'Quién está mirando',
    watching: 'Mirando: {{count}}',
    viewerPlaying: 'Juega',
    viewerWatching: 'Mira',
    viewersEmpty: 'Nadie todavía',
    sellDrops: 'Vender todo por',
    sellConfirmTitle: '¿Vender todos los drops?',
    sellConfirmText: 'Los objetos salen de tu inventario y las monedas llegan a tu saldo. No se puede deshacer.',
    soldFor: 'Vendido. {{amount}} ya están en tu saldo',
    sellFailed: 'No se pudo vender',
    repeatLineup: 'Repetir el battle',
    recreateBattle: 'Volver a crear el battle',
    recreateLimit: 'Alcanzaste el límite de battles activos',
    recreateFailed: 'No se pudo crear el battle',
    replay: 'Ver de nuevo',
    toBattles: 'A los battles',
    rematchOf: 'Es una revancha: abrir el primer battle',
    cancelledTitle: 'Battle cancelado',
    cancelledTimeout: 'En 10 minutos no se unió nadie',
    cancelledEmpty: 'Todos los participantes se fueron',
    cancelledProcessing: 'El sorteo falló y se devolvieron las entradas',
    cancelledBandFailed: 'No se pudo jugar el battle y ya estamos en ello. Los pagos llegarán en cuanto lo arreglemos.',
    cancelledBandCarried:
      'El battle de los cabezas de cartel no se celebró: se acabaron las cajas. El importe para cajas pasa a la semana siguiente.',
    refunded: 'Tu entrada de {{amount}} volvió a tu saldo',
    share: 'Compartir',
    inviteFriend: 'Invitar a un amigo',
    inviteText: 'Entra a mi Case Battle en SHOT: hay un lugar para ti',
    inviteButton: 'Jugar',
    linkCopied: 'Enlace copiado',
  },
  pl: {
    round: 'Runda',
    join: 'Dołącz za',
    leave: 'Wyjdź',
    starting: 'Startujemy…',
    youWon: 'Wygrałeś',
    youTookAll: 'Zgarnąłeś wszystko',
    yourSideWon: 'Twoja strona wygrała',
    playerWon: 'Wygrał {{name}}',
    howHighest: 'Wydropił najwięcej — {{amount}}',
    howLowest: 'Wydropił najmniej — {{amount}}',
    howLastCase: 'Drop z ostatniej skrzynki — {{amount}}',
    howSideHighest: 'Wydropili więcej:',
    howSideLowest: 'Wydropili mniej:',
    versus: 'kontra',
    howTied: 'Wydropili tyle samo — po {{amount}}',
    tookAllDropped: 'wszystko, co wydropili wszyscy gracze',
    eachFromDropped: 'każdemu z {{amount}} wydropionych',
    received: 'Otrzymano',
    superDrop: 'Super drop',
    finalRound: 'Decydująca runda',
    finalRoundHint: 'Liczy się tylko ten drop',
    sharingTitle: 'Dzielimy po równo',
    teamWon: 'Zwycięska drużyna',
    tie: 'Remis',
    dropped: 'Wydropiono',
    lastDrop: 'Ostatni drop',
    errorJoining: 'Nie udało się dołączyć',
    errMultiacc: 'Nie możesz wziąć udziału w tym battle',
    errorLeaving: 'Nie udało się wyjść',
    errorReady: 'Nie udało się oznaczyć gotowości',
    you: 'Ty',
    playerFallback: 'Gracz',
    preparingAnimation: 'Przygotowujemy powtórkę…',
    lobbySlotFree: 'Wolne',
    lobbyYou: 'Ty',
    takeSeat: 'Usiądź tutaj',
    gathering: 'Zbieramy graczy',
    bandStartsAt: 'Zacznie się o {{time}} czasu moskiewskiego',
    privateTitle: 'Prywatny battle',
    privateHint: 'Nie ma go na liście. Wyślij link tym, na których czekasz.',
    readyBadge: 'gotowy',
    startNowTitle: 'Startuj teraz',
    readyCount: '{{count}} z {{total}} gotowych',
    topUpShort: 'Brakuje {{missing}} — doładuj konto',
    addTradeLink: 'Podaj link do wymiany',
    joinConfirmTitle: 'Dołączyć do battle?',
    chooseSide: 'Którą drużynę wybierasz?',
    sideFull: 'Zajęte',
    cancel: 'Anuluj',
    modeRuleTitle: 'Jak wyłaniany jest zwycięzca',
    viewersTitle: 'Kto ogląda',
    watching: 'Oglądają: {{count}}',
    viewerPlaying: 'Gra',
    viewerWatching: 'Ogląda',
    viewersEmpty: 'Na razie nikogo',
    sellDrops: 'Sprzedaj wszystko za',
    sellConfirmTitle: 'Sprzedać wszystkie dropy?',
    sellConfirmText: 'Przedmioty znikną z ekwipunku, a monety trafią na saldo. Nie można tego cofnąć.',
    soldFor: 'Sprzedano. {{amount}} jest już na saldzie',
    sellFailed: 'Nie udało się sprzedać',
    repeatLineup: 'Powtórz battle',
    recreateBattle: 'Utwórz battle ponownie',
    recreateLimit: 'Osiągnięto limit aktywnych battle',
    recreateFailed: 'Nie udało się utworzyć battle',
    replay: 'Obejrzyj ponownie',
    toBattles: 'Do battle',
    rematchOf: 'To rewanż — otwórz pierwszy battle',
    cancelledTitle: 'Battle odwołany',
    cancelledTimeout: 'W ciągu 10 minut nikt nie dołączył',
    cancelledEmpty: 'Wszyscy uczestnicy wyszli',
    cancelledProcessing: 'Losowanie się nie udało, wejścia zostały zwrócone',
    cancelledBandFailed:
      'Nie udało się rozegrać battle — już nad tym pracujemy. Wypłaty dotrą, gdy tylko to naprawimy.',
    cancelledBandCarried:
      'Battle headlinerów się nie odbył — skończyły się na niego skrzynki. Kwota na skrzynki przechodzi na następny tydzień.',
    refunded: 'Twoje wejście za {{amount}} wróciło na saldo',
    share: 'Udostępnij',
    inviteFriend: 'Zaproś znajomego',
    inviteText: 'Wskakuj do mojego case battle na SHOT — jest dla ciebie miejsce',
    inviteButton: 'Graj',
    linkCopied: 'Link skopiowany',
  },
});
